import { call, put, takeLatest, select, delay } from 'redux-saga/effects';
import { push } from 'connected-react-router'
import { createRoutine } from 'redux-saga-routines'
import moment from 'moment-timezone'

import { loginUser, logoutUser, loggedInUser, updateMeToken } from './index.reducer'
import { saveToken, updateToken, refreshAccessToken } from '../index.reducer'
import Api from '../../services/ApiCaller'
import { IAppState } from '../../store/state.interface.web'

export const checkTokenExpiry = createRoutine('CHECK_TOKEN_EXPIRY')

function* loginRequest({ setHeader, api }: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error } = res
    if (!error && res.accessToken) {
      const { accessToken: token, refreshToken, ...user } = res
      yield put(
        loginUser.success({
          user,
          token
        })
      )
      yield put(
        saveToken.success({
          token,
          refreshToken
        })
      )
      yield put(updateMeToken.success({
        token
      }))
      yield put(checkTokenExpiry())
      setHeader('Authorization', `Bearer ${token}`)
      yield put(push('/dashboard'))
    } else {
      yield put(loginUser.failure())
    }
  } catch (e) {
    yield put(loginUser.failure(e.message))
  }
}

function* fetchSaga() {
  while (true) {
    yield delay(300000)
    const state: IAppState = yield select()
    const refreshToken = state.auth.refreshToken
    const expiryTime = state.auth.expiryTime
    if (refreshToken && expiryTime && (moment(expiryTime).diff(moment().unix()) <= 300)) {
      yield put(refreshAccessToken({
        token: refreshToken
      }))
    }
  }
}

function* loggedInUserRequest({ setHeader, api }: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload)
    const { error, message } = res
    if (!error && res.id) {
      const { refreshToken, ...user } = res
      yield put(
        loginUser.success({
          user
        })
      )

      yield put(
        updateToken.success({
          refreshToken
        })
      )
      yield put(checkTokenExpiry())
    } else {
      yield put(loginUser.failure(message))
    }
  } catch (e) {
    yield put(loginUser.failure(e.message))
  }
}

function* logoutUserRequest(deleteHeader: any) {
  try {
    yield delay(200)
    deleteHeader('Authorization')
    yield put(logoutUser.success())

    yield put(
      updateToken.success({
        token: '',
        refreshToken: '',
        expiryTime: null
      })
    )

    yield put(push('/login'))
  } catch (e) {
    console.error(e)
  }
}

function* refreshTokenRequest({ setHeader, api }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, {}, false)
    const { error } = res

    if (!error && res.accessToken) {
      yield put(
        saveToken.success({
          token: res.accessToken,
          refreshToken: res.refreshToken
        })
      )
      setHeader('Authorization', `Bearer ${res.accessToken}`)
    }
  } catch (e) {
    console.error(e)
  }
}


export default (api: any) => {
  const loginApi = (data: any) => {
    return api.post('/auth/login', data)
  }
  const loggedInUserApi = () => {
    return api.get('/auth/me')
  }

  const refreshTokenApi = (data: any) => {
    return api.get('/auth/refresh', data)
  }
  return [
    takeLatest(loginUser.TRIGGER, loginRequest, {
      setHeader: api.setHeader,
      api: loginApi
    }),
    takeLatest(loggedInUser.TRIGGER, loggedInUserRequest, { setHeader: api.setHeader, api: loggedInUserApi }),
    takeLatest(refreshAccessToken.TRIGGER, refreshTokenRequest, { setHeader: api.setHeader, api: refreshTokenApi }),
    takeLatest(checkTokenExpiry.TRIGGER, fetchSaga),
    takeLatest(logoutUser.TRIGGER, logoutUserRequest, api.deleteHeader)
  ]
}
